import { TabGroup, TabGroupItem } from '@/Components/TabGroup/TabGroup';
import type NewWordsStore from '@/Stores/NewWords/NewWordsStore';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NewWordStatus from '../../../Models/NewWords/NewWordStatus';
import NewWordsTab from './NewWordsTab';
import Styles from './NewWordsTabs.module.scss';

const NewWordsTabs = observer(({ store }: { store: NewWordsStore }): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <div className={Styles.container}>
            <TabGroup>
                <TabGroupItem value={1} name={t('New')} active={store.state.selectedNewWordsState === NewWordStatus.New} onClick={(val) => store.setSelectedNewWordsStatusAndReloadTable(val as number)} />
                <TabGroupItem value={2} name={t('Approved')} active={store.state.selectedNewWordsState === NewWordStatus.Approved} onClick={(val) => store.setSelectedNewWordsStatusAndReloadTable(val as number)} />
                <TabGroupItem value={3} name={t('Ignored')} active={store.state.selectedNewWordsState === NewWordStatus.Ignored} onClick={(val) => store.setSelectedNewWordsStatusAndReloadTable(val as number)} />
            </TabGroup>
            <div className={Styles.tabContainer}>
                <NewWordsTabPanel value={store.state.selectedNewWordsState} index={1}>
                    <NewWordsTab statusOfWords={NewWordStatus.New} store={store} />
                </NewWordsTabPanel>
                <NewWordsTabPanel value={store.state.selectedNewWordsState} index={2}>
                    <NewWordsTab statusOfWords={NewWordStatus.Approved} store={store} />
                </NewWordsTabPanel>
                <NewWordsTabPanel value={store.state.selectedNewWordsState} index={3}>
                    <NewWordsTab statusOfWords={NewWordStatus.Ignored} store={store} />
                </NewWordsTabPanel>
            </div>
        </div>
    );
});

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function NewWordsTabPanel(props: Readonly<TabPanelProps>): React.ReactElement {
    const { children, value, index } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

export default NewWordsTabs;
